export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00112.d17e0c2f.png";